import React from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import {
  Box,
  IconShareArrow,
  useDialogController,
  useResponsiveValue
} from '@machobear/design-system'

import { Listing } from '@/types'
import structure from '@/structure'
import { breakpoints, colors } from '@/styles'
import useRole from '@/hooks/use-role'
import DSLoginModal from '@/features/Auth/login-modal/ds-login-modal'
import BackBtn from '@/components/back-btn'
import FavouriteButton from '@/components/favourite-button-new'

type Props = {
  listings: Listing
  handleShare: () => void
}

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px 0 16px;
  border-top: 1px solid ${colors.grey88};

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    height: 90px;
  }
`

const ControlButtons = styled.div`
  display: flex;
  gap: 8px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    display: none;
  }
`

const DesktopHeader = ({ listings, handleShare }: Props) => {
  const { t } = useTranslation()
  const isMobile = useResponsiveValue()({ mobile: true, tablet: false })
  const role = useRole()
  const isLandlord = role === 'landlord'

  const {
    visible: loginModalVisible,
    showModal: showLoginModal,
    closeModal: closeLoginModal
  } = useDialogController()

  return (
    <>
      <Box width="full" background="white">
        <HeaderContent>
          <Box
            display="flex"
            justifyContent="spaceBetween"
            width="full"
            alignItems="center"
            style={{
              margin: '0 32px',
              maxWidth: structure.desktop.page
            }}
          >
            <Box display="flex" alignItems="center" gap="small">
              <BackBtn
                iconSize={isMobile ? 'medium' : 'xlarge'}
                showText={!isMobile}
              />
            </Box>
            {!isMobile && (
              <ControlButtons>
                <Box
                  cursor="pointer"
                  onClick={handleShare}
                  id="listing-detail-share-click"
                >
                  <Box style={{ pointerEvents: 'none' }}>
                    <IconShareArrow size="medium" />
                  </Box>
                </Box>
                {!isLandlord && (
                  <FavouriteButton
                    listingId={listings.id}
                    id="listing-details-click-favourite"
                    showDSLoginModal={showLoginModal}
                  />
                )}
              </ControlButtons>
            )}
          </Box>
        </HeaderContent>
      </Box>

      <DSLoginModal
        mode="login"
        visible={loginModalVisible}
        onClose={closeLoginModal}
        t={t}
      />
    </>
  )
}

export default DesktopHeader
